import React, { useState } from 'react'
import { Link } from 'gatsby'
import * as styles from './Footer.module.scss'

const Footer = () => {
  return (
    <footer className={styles.root}>
      <div className={styles.footerContainer}>
        <img
          src="/img/logo.svg"
          className={styles.footerLogo}
          alt="cp rewards logo footer"
        />
        <div className={styles.social}>
          <a
            href="https://x.com/CP_News"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/img/footer/x.svg" alt="x logo" />
          </a>
          <a
            href="https://www.youtube.com/channel/UCA-uIKLCzTJSI1HdGyfmsDQ"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/img/footer/youtube.svg" alt="youtube logo" />
          </a>
          <a
            href="https://www.instagram.com/colgatepalmoliveco/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/img/footer/instagram.svg" alt="instagram logo" />
          </a>
        </div>
        <ul className={styles.links}>
          <li>
            <Link to="/faq">Frequently Asked Questions</Link>
          </li>
          <li>
            <Link to="/program-terms">Program Terms</Link>
          </li>
          <li>
            <Link to="/terms">Terms of Use</Link>
          </li>
          <li>
            {/* <a
              href="https://www.colgatepalmolive.com/en-us/legal-privacy-policy"
              target="_blank"
            >
              Privacy Policy
            </a> */}
            <Link to="/privacy">Privacy Policy</Link>
          </li>
          <li>
            <a
              href="https://www.colgatepalmolive.com/en-us/legal-privacy-policy/terms-of-use"
              target="_blank"
            >
              Terms &amp; Conditions
            </a>
          </li>
          <li>
            <a
              href="#"
              onClick={() => {
                window.truste.eu && window.truste.eu.clickListener(2)
              }}
            >
              Cookie Consent Tool
            </a>
          </li>
        </ul>
        <ul className={styles.links}>
          <li>© 2024 Breaktime Media MWH LLC. All rights reserved.</li>
          <li></li>© 2024 Colgate-Palmolive Company. All rights reserved.
        </ul>
      </div>
    </footer>
  )
}

export default Footer
